import { FC } from 'react'
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

/**
 * Props for `IconPanels`.
 */
export type IconPanelsProps = SliceComponentProps<Content.IconPanelsSlice>;

/**
 * Component for "IconPanels" Slices.
 */
const IconPanels: FC<IconPanelsProps> = ({ slice }) => {
  const panels = slice.primary.panels || [];
  const threeColumns = slice.primary.column_setting; // true = 3 cols, false = 2 cols
  const leftAlign = slice.primary.left_align;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div
        className={`font-fellix ${slice.primary.background?.toLowerCase()} ${
          slice.primary.display_panels ? 'bg-lightgrey' : ''
        } px-4 md:px-8 lg:px-16 `}
      >
        <div className="max-w-[1280px] mx-auto py-12">
          {slice.primary.title && (
            <article className="font-semibold text-[40px] leading-[60px] mt-0 mx-auto mb-[50px] text-center">
              <PrismicRichText field={slice.primary.title} />
            </article>
          )}

       <div className="flex flex-wrap justify-center gap-6 md:gap-10 lg:gap-16">
        {panels.map((item: any, index: number) => {
          const isThreeCols = threeColumns;
          const baseWidth = isThreeCols ? 'md:basis-1/4' : 'md:basis-1/3';

          return (
            <div
              key={index}
              className={`
                ${baseWidth} basis-full
                flex flex-col py-12
                ${slice.primary.display_panels ? 'bg-white px-4 md:px-8' : ''}
              `}
            >
              <div className="bg-white py-4 flex flex-col h-full text-center items-center">
                <div className="h-[120px]">
                  <PrismicNextImage
                    field={item.icon}
                    fallbackAlt=""
                    className="block mx-auto max-h-[90px] mb-9"
                  />
                </div>

                <div className="flex-grow w-full">
                  <article className="text-[20px] leading-[28px] font-semibold my-[13px] text-center">
                    <PrismicRichText field={item.panel_title} />
                  </article>
                  <article
                    className={`text-[18px] leading-[26px] font-normal mb-0 prose prose-a:no-underline prose-a:hover:underline prose-a:text-blue-500 ${
                      leftAlign ? 'text-left' : 'text-center'
                    }`}
                  >
                    <PrismicRichText field={item.paragraph} />
                  </article>
                </div>

                {item.button_link?.link_type !== 'Any' && (
                  <div className="mt-auto pt-4 mx-auto">
                    <PrismicNextLink
                      field={item.button_link}
                      className="border-jade border-[1px] text-jade hover:text-white hover:bg-jade rounded-full h-[56px] pt-3 px-8 items-center text-center duration-300 cursor-pointer inline-block"
                    >
                      {item.button_text}
                    </PrismicNextLink>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

          {slice.primary.fineprint ? 
            <div className="text-[14px] leading-[18px] my-8 max-w-[550px] mx-auto text-center">
              <PrismicRichText field={slice.primary.fineprint}/>
            </div>  : <></>}
        </div>
      </div>
    </section>
  )
}

export default IconPanels;
